import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";

import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import { convertValueToMoney, convertValueToPhoneNumber } from "../../utils/utils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
class PlayerTextInput extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		this.state = {
			value: this.props.item.value
		};

		autoBind(this);
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	onBlur(event) {
			this.handleOnChangeCallback(event.target.value);
	}

	handleOnChangeCallback(value) {
		if (this.props.onChange) {
			const{ listIndex, sectionIndex, itemIndex, disabled} = this.props;
			this.props.onChange({ value, listIndex, sectionIndex, itemIndex, disabled });
		}
	}

	onChange(event) {

		let value = event.target.value;

		if (!_.isUndefined(value) && value !== "") {

			if (this.props.item.textInputMaskType === "money") {
				const currencySymbol = this.props.item.hasOwnProperty("currencySymbol") ? this.props.item.currencySymbol : "$";
				const currencySeparator = this.props.item.hasOwnProperty("currencySeparator") ? this.props.item.currencySeparator : ",";
				value = convertValueToMoney(value, currencySymbol, currencySeparator);
			}

			if (this.props.item.textInputMaskType === "phone") {
				if (value.length < 14) {
					value = convertValueToPhoneNumber(value);
				}
				else if (value.length === 14) {
					value = convertValueToPhoneNumber(value);
					//blur here
						this.handleOnChangeCallback(value);
				}
				else {
					value = value.substring(0, value.length - 1);
				}
			}
		}
		this.setState({ value: value });
	}

	triggerOnBlur() {
		this.onBlur({ target: { value: this.state.value } });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.item.value !== this.props.item.value) {
			this.setState({ value: nextProps.item.value });
		}
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	detectEnterKeyAndSubmit(e) {
		if (e.keyCode === 13) {
			// Simulate clicking on the submit button.
			e.target.blur();
			this.onSubmit();
		}
	}

	renderEditable() {
		const { item, getLabels, getImage, getVideo, getPdf, disabled } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const textInputTheme = _.get(theme, "item.textInput");

		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%" }}>
				{getLabels()}
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div>
					<input
						style={textInputTheme}
						className="form-control"
						type="text"
						value={this.state.value}
						onChange={this.onChange}
						onBlur={(e) => { this.onBlur(e); }}
						// onClick={(e) => {
						// 	if (!item.selected) {
						// 		this.textInput.blur();
						// 	} else {
						// 		this.textInput.focus();
						// 		global.container.scrollBy(0,1);
						// 		global.container.scrollBy(0,-1);
						// 	}
						// }}
						disabled={disabled}
						onFocus={() => {
							global.container.scrollBy(0, 10);
							global.container.scrollBy(0, -10);
						}}
						onKeyUp={this.detectEnterKeyAndSubmit}
						placeholder={item.hasOwnProperty("textInputPlaceholder") ? item.textInputPlaceholder : ""}
						maxLength={Number(item.hasOwnProperty("textInputMaxLength") ? item.textInputMaxLength : -1)}
						autoCapitalize={item.hasOwnProperty("textInputKeyboardAutoCapitalize") ? item.textInputKeyboardAutoCapitalize : "sentences"}
						autoCorrect={item.hasOwnProperty("textInputKeyboardAutoCorrect") ? item.textInputKeyboardAutoCorrect : true}
						ref={(ref) => { this.textInput = ref; }} />
				</div>
				{!disabled && <div>
					<DoneButton onSubmit={this.onSubmit} />
				</div>}
			</div>
		</div>;
		return component;
	}
}

export default withPlayerItemHoc(PlayerTextInput);